import React from "react";
import { Radio, Button, Tooltip, Space } from "antd";
import { Views } from "react-big-calendar";
import { useIntl } from "react-intl";
import { ScheduleOutlined, UserSwitchOutlined } from "@ant-design/icons";
import Header from "./Header";
import { useParams } from "react-router-dom";

const SchedulingHeader = (props) => {
  const {
    onChangeView,
    onFilterPatientsChanged,
    ordersIds,
    events,
    patientsPallette,
    calenderView,
    currentDate,
    onNextDate,
    onPreviousDate,
    onlaunchApprovalModal,
    onLaunchReplacementsModal,
    order_time_extractions,
    filteredOrders,
    activeEmployee,
  } = props;
  const intl = useIntl();
  let { branchId } = useParams();

  const Comp = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "column",
        width: "250px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "inherit",
        }}
      >
        <Space size="small">
          <Radio.Group onChange={onChangeView} value={calenderView}>
            <Radio.Button value={Views.DAY}>
              {intl.formatMessage({
                id: "app.scheduling.day",
              })}
            </Radio.Button>
            <Radio.Button value={Views.WEEK}>
              {intl.formatMessage({
                id: "app.scheduling.week",
              })}
            </Radio.Button>
            <Radio.Button value={Views.MONTH}>
              {intl.formatMessage({
                id: "app.scheduling.month",
              })}
            </Radio.Button>
          </Radio.Group>
          <Tooltip
            title={intl.formatMessage({
              id: "app.scheduling.replacements",
            })}
          >
            <Button
              type="text"
              icon={<UserSwitchOutlined />}
              onClick={() => onLaunchReplacementsModal()}
            />
          </Tooltip>

          <Tooltip
            title={intl.formatMessage({
              id: "app.scheduling.approval",
            })}
          >
            <Button
              type="text"
              icon={<ScheduleOutlined />}
              onClick={() => onlaunchApprovalModal()}
            />
          </Tooltip>
        </Space>
      </div>
    </div>
  );

  return (
    <div style={{ display: "flex" }}>
      <Header
        currentDate={currentDate}
        onNextDate={onNextDate}
        onPreviousDate={onPreviousDate}
        onFilterPatientsChanged={onFilterPatientsChanged}
        ordersIds={ordersIds}
        events={events}
        patientsPallette={patientsPallette}
        calenderView={calenderView}
        comp={<Comp />}
        order_time_extractions={order_time_extractions}
        filteredOrders={filteredOrders}
        activeEmployee={activeEmployee}
      />
    </div>
  );
};

export default SchedulingHeader;
